import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';

import Layout from 'components/Layout';
import Meta from 'components/Meta';
import Banner from 'components/Banner';
import SectionContact from 'components/SectionContact';

import CheckIcon from 'images/icons/check.svg';

import { SolutionsDetail } from 'styles/solutions-detail';
import SolutionSteps from '../../components/SolutionSteps/SolutionSteps';

const SolutionCSDPage = ({ path }) => (
  <>
    <Meta title="Custom Mobile Application Development | Solutions" />
    <Layout background="#ffffff" path={path}>
      <SolutionsDetail>
        <Banner
          backgroundSrc="partners/partners-bg.jpg"
          title="Custom Mobile Application Development."
          className="darken-image"
          style={{ paddingBottom: 100 }}
        >
          <p
            className="white-txt"
            style={{
              fontSize: 18,
              letterSpacing: 0.2,
              lineHeight: '28px',
            }}
          >
            Meet your consumer where they are: on their phone.
          </p>
          <Link
            to="/contact-us/"
            className="pink-btn"
            style={{ minWidth: 180 }}
          >
            <span>Build your own app</span>
          </Link>
          <a
            href="#brief"
            onClick={(e) => {
              e.preventDefault();
              if (typeof window !== 'undefined')
                window.scrollb.scrollIntoView(document.getElementById('brief'));
            }}
            className="white-btn brief-btn"
          >
            <span>What to expect</span>
          </a>
        </Banner>

        <section className="principle-main">
          <div className="container">
            <div className="row">
              <div className="col-md-12 col-lg-8">
                <h2 className="medium-heading">
                  Use Case for Building Your Mobile App
                </h2>
                <p className="white-txt">
                  According to the latest Gartner research (2019), “Mobile Apps
                  Are Projected to Have the Most Impact on Business Success By
                  2020.” From mobile app downloads, advertising, and in-app
                  purchases, the revenue streams offered by apps are
                  unparalleled. They are projected to cross $188 billion by
                  2020. Courtesy: Statista research data. While there is a clear
                  business case for building apps, you still have to choose from
                  a host of technologies, tools, and application development
                  frameworks. Let us help.
                </p>
              </div>
            </div>
          </div>
        </section>

        <SolutionSteps
          id="customMobileAppDevelopment"
          flyText="Mobile Application Development"
        />

        <section id="brief">
          <div className="grey-bg center">
            <div className="container">
              <div className="featured-partner-block">
                <h2 className="medium-heading black-txt">
                  App Development Made Easy With Expertise
                </h2>
                <p>
                  Leveraging our extensive experience in JavaScript, which has
                  emerged as the de facto standard in mobile and web app
                  development, ATC specializes in building immersive apps using
                  frameworks such as Adobe PhoneGap, React Native, Xamarin,
                  Ionic, and Flutter. Understanding frameworks in other aspects
                  of business allows us to perfect application development, as
                  well.
                </p>
                <Link
                  to="/contact-us/"
                  className="pink-btn d-none d-md-inline-block"
                >
                  <span>Talk to an Expert</span>
                </Link>
              </div>
            </div>
          </div>
        </section>
        <section>
          <div className="why-partner-main">
            <div className="container">
              <div className="row">
                <div className="col-md-4">
                  <h2 className="big-heading">
                    More than just
                    <br />
                    an app.
                    <span className="pink">.</span>
                  </h2>
                </div>
                <div className="col-md-8">
                  <div className="row">
                    <div className="col-md-6 col-6">
                      <div className="why-partner-single">
                        <span className="why-partner-icon">
                          <CheckIcon />
                        </span>
                        <h3>Insights</h3>
                        <p>
                          AI UX insights evolve apps based on real user data.
                        </p>
                      </div>
                    </div>
                    <div className="col-md-6 col-6">
                      <div className="why-partner-single">
                        <span className="why-partner-icon">
                          <CheckIcon />
                        </span>
                        <h3>Testing</h3>
                        <p>Mobile App testing to remove all bugs.</p>
                      </div>
                    </div>
                    <div className="col-md-6 col-6">
                      <div className="why-partner-single">
                        <span className="why-partner-icon">
                          <CheckIcon />
                        </span>
                        <h3>Features</h3>
                        <p>
                          Push notifications, payment, and ads functionalities.
                        </p>
                      </div>
                    </div>
                    <div className="col-md-6 col-6">
                      <div className="why-partner-single">
                        <span className="why-partner-icon">
                          <CheckIcon />
                        </span>
                        <h3>Security</h3>
                        <p>Ongoing analytics and security.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <SectionContact />
      </SolutionsDetail>
    </Layout>
  </>
);

SolutionCSDPage.propTypes = {
  path: PropTypes.string.isRequired,
};

export default SolutionCSDPage;
